import React from 'react';

import SectionBreakTitle, { SectionColor } from '@components/SectionBreakTitle';
import Spinner from '@components/Spinner';
import { useEmailSettings, useNewsletterSubscriptions } from '@hooks';

import SettingHeaderSeperator from '../SettingHeaderSeperator';
import EmailSettings from './EmailSettings';
import NotificationSettings from './NotificationSettings';

const EmailPreferences = () => {
  const { newsletters, isLoadingNewsletterSubscriptions } = useNewsletterSubscriptions();
  const { userEmailSettings, isLoadingUserEmailSettings } = useEmailSettings();

  if (isLoadingNewsletterSubscriptions || isLoadingUserEmailSettings) return <Spinner />;

  return (
    <div>
      <SectionBreakTitle
        className="mb-32"
        titleClassName="text-primary-magenta"
        color={SectionColor.Magenta}
        title="Email preferences"
      />
      <div className="mb-24 font-suisse-intl text-description-lg">
        Update your subscription to our newsletters:
      </div>
      <EmailSettings newsletters={newsletters} userEmailSettings={userEmailSettings} />
      <SettingHeaderSeperator sectionName="Other" />
      <NotificationSettings userEmailSettings={userEmailSettings} />
    </div>
  );
};

export default EmailPreferences;
